import type { ReactElement } from 'react';
import React from 'react';

interface TableCell {
    value: string | ReactElement;
    className?: string;
}

interface TableProps {
    header: string[];
    rows: TableCell[][];
}

function Table({ header, rows }: TableProps) {
    return (
        <table className="table-responsive-label table">
            <thead>
                <tr>
                    {header.map((title) => (
                        <th key={title}>{title}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                        {row.map(({ value, className }, dataIndex) => (
                            <td
                                key={dataIndex}
                                data-label={header[dataIndex]}
                                className={className}
                            >
                                {value}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

export default Table;
